import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getReference = createSelector(property('reference'), identity);
export const isLoaded = createSelector(getReference, property('isLoaded'));
export const getError = createSelector(getReference, property('error'));



// WEBPACK FOOTER //
// ./src/modules/ReferenceDetail/selectors/index.js